export enum BuilderCatalogFlag {
  AVAILABLE = -1,
  PARTIAL = -2,
  NOT_IN_DATASET = -3,
}
